import { render, staticRenderFns } from "./SimpleKeyboardCommon.vue?vue&type=template&id=74ec8456&"
import script from "./SimpleKeyboardCommon.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyboardCommon.vue?vue&type=script&lang=js&"
import style0 from "./SimpleKeyboardCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports